/**
 * Main layout for initial landing page section
 * Sets the entire layout to 100vh
 */
import React, { useState } from 'react';

// Material imports
import { Grid } from '@material-ui/core';

// landing section style imports
import { LandingSectionContainer,
  LandingSectionInfoContainer,
  LandingSectionInfoProfilePicture,
  LandingSectionPill, 
  LandingSectionHeader, 
  LandingSectionTypistContainer,
  LandingSectionSocialIcon,
  LandingSectionSocialLink,
  LandingSectionMoreInfoArrow,
  LandingSectionArrowContainer,
  LandingSectionLinksContainer,
} from '../../../styles/sectionStyles/LandingSectionStyles';

// typist import loop
import Typist from 'react-typist';
import "react-typist/dist/Typist.css";

// profile picture import
// import profilePicture from '../../../assets/ProfilePicture.jpeg';

// social icon imports
import linkedinLogo from "../../../assets/LinkedinLogo.png";
import githubLogo from "../../../assets/GithubLogo.png";
import cvIcon from "../../../assets/CvIcon.svg";

// down arrow import
import moreInformationArrowDown from '../../../assets/DownArrow.svg';

// react-reveal fade animation
import { Fade } from 'react-reveal';

// particle background import
import LandingBackground from './LandingBackground';

import { buildImageObj } from "../../../../core/sanity/lib/helpers";
import { imageUrlFor } from "../../../../core/sanity/lib/image-url";

export function LandingSection({ profilePicture, roles }) {
  const [typistIndex, setTypistIndex] = useState(0);

  return (
    <>
      <Fade fraction={0.4}>
        <LandingSectionContainer id='home' >
          <LandingBackground />
          <Grid container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{height: 'calc(80%)'}}
          >
            <Grid item>
              <LandingSectionInfoContainer>
                <LandingHeaderText profilePicture={profilePicture} />
                <LandingSectionPill id='pill'/>
                <LandingSectionTypistContainer id='typist'>
                  <Typist
                    key={typistIndex}
                    onTypingDone={() => setTypistIndex(typistIndex + 1)}
                  >
                    {typistIndex === 0 && <Typist.Delay ms={6000} />}
                    {roles.map(word => ([
                      <span>{word}</span>,
                      <Typist.Backspace count={word.length} delay={10000} />,
                    ]))}

                  </Typist>
                </LandingSectionTypistContainer>
                <LandingSectionLinksContainer id='landingLinksContainer'>
                  {/*linkedinLogo*/}
                  <LandingSectionSocialLink
                    href="https://www.linkedin.com/in/john-dao/"
                    aria-label="Linkedin"
                  >
                    <LandingSectionSocialIcon 
                      src={linkedinLogo} 
                      alt='linkedin logo link'
                    />
                  </LandingSectionSocialLink>
                  {/*github logo*/}
                  <LandingSectionSocialLink
                    href="https://github.com/jnddao"
                    aria-label="Github"
                  >
                    <LandingSectionSocialIcon 
                      src={githubLogo} 
                      alt='github logo link'
                    />
                  </LandingSectionSocialLink>
                  <LandingSectionSocialLink
                    href="/resume.pdf"
                    aria-label="Resume"
                  >
                    <LandingSectionSocialIcon 
                      src={cvIcon} 
                      alt='resume logo link'
                    />
                  </LandingSectionSocialLink>
                  {/* <LandingSectionSocialLink
                    href="/blog">
                      <LandingSectionBlogIcon>
                        <FaBloggerB />
                        Blog
                      </LandingSectionBlogIcon>
                  </LandingSectionSocialLink> */}
                </LandingSectionLinksContainer>
                <LandingSectionArrowContainer id='moreInfoArrowContainer' onClick={() => {document.getElementById('about').scrollIntoView({behavior: 'smooth'})}}>
                  <LandingSectionMoreInfoArrow  src={moreInformationArrowDown} alt='scroll for more information arrow'/>
                </LandingSectionArrowContainer>
              </LandingSectionInfoContainer>
            </Grid>
          </Grid>
        </LandingSectionContainer>
        
      </Fade>

    </>
  )
}

function LandingHeaderText ({profilePicture}) {
  return (
    <LandingSectionHeader>
      <LandingSectionInfoProfilePicture id='profilePicture' 
      src={imageUrlFor(buildImageObj(profilePicture))
        .width(500)
        .height(500)
        .fit("crop")
        .url()} 
      alt={profilePicture.alt}/>
        <svg id='nameLogo' viewBox="0 0 316 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M28.5278 4.67969H35.5957V42.436C35.5957 47.5386 34.0576 51.5303 30.9814 54.4111C27.9297 57.292 23.8525 58.7324 18.75 58.7324C13.4521 58.7324 9.32617 57.3774 6.37207 54.6675C3.41797 51.9575 1.94092 48.1611 1.94092 43.2783H8.97217C8.97217 46.3301 9.80225 48.7104 11.4624 50.4194C13.147 52.1284 15.5762 52.9829 18.75 52.9829C21.6553 52.9829 23.999 52.0674 25.7812 50.2363C27.5879 48.4053 28.5034 45.8418 28.5278 42.5459V4.67969Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M44.7144 37.8218C44.7144 33.9399 45.4712 30.4487 46.9849 27.3481C48.5229 24.2476 50.647 21.855 53.3569 20.1704C56.0913 18.4858 59.2041 17.6436 62.6953 17.6436C68.0908 17.6436 72.4487 19.5112 75.769 23.2466C79.1138 26.9819 80.7861 31.9502 80.7861 38.1514V38.6274C80.7861 42.4849 80.0415 45.9517 78.5522 49.0278C77.0874 52.0796 74.9756 54.46 72.2168 56.1689C69.4824 57.8779 66.333 58.7324 62.7686 58.7324C57.3975 58.7324 53.0396 56.8647 49.6948 53.1294C46.3745 49.394 44.7144 44.4502 44.7144 38.2979V37.8218ZM51.5259 38.6274C51.5259 43.022 52.5391 46.5498 54.5654 49.2109C56.6162 51.8721 59.3506 53.2026 62.7686 53.2026C66.2109 53.2026 68.9453 51.8599 70.9717 49.1743C72.998 46.4644 74.0112 42.6802 74.0112 37.8218C74.0112 33.4761 72.9736 29.9604 70.8984 27.2749C68.8477 24.5649 66.1133 23.21 62.6953 23.21C59.3506 23.21 56.6528 24.5405 54.6021 27.2017C52.5513 29.8628 51.5259 33.6714 51.5259 38.6274Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M96.0571 23.1733C99.0601 19.4868 102.966 17.6436 107.776 17.6436C116.15 17.6436 120.374 22.3677 120.447 31.8159V58H113.672V31.7793C113.647 28.9229 112.988 26.811 111.694 25.4438C110.425 24.0767 108.435 23.3931 105.725 23.3931C103.528 23.3931 101.599 23.979 99.939 25.1509C98.2788 26.3228 96.9849 27.8608 96.0571 29.7651V58H89.2822V1.75H96.0571V23.1733Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M137 18.376L137.219 23.3564C140.247 19.5479 144.202 17.6436 149.084 17.6436C157.458 17.6436 161.682 22.3677 161.755 31.8159V58H154.98V31.7793C154.956 28.9229 154.297 26.811 153.003 25.4438C151.733 24.0767 149.744 23.3931 147.034 23.3931C144.836 23.3931 142.908 23.979 141.248 25.1509C139.587 26.3228 138.293 27.8608 137.366 29.7651V58H130.591V18.376H137Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M191.638 58V4.67969H206.689C211.328 4.67969 215.43 5.70508 218.994 7.75586C222.559 9.80664 225.305 12.7241 227.234 16.5083C229.187 20.2925 230.176 24.6382 230.2 29.5454V32.9512C230.2 37.9805 229.224 42.3872 227.271 46.1714C225.342 49.9556 222.571 52.8608 218.958 54.8872C215.369 56.9136 211.182 57.9512 206.396 58H191.638ZM198.669 10.4658V52.2505H206.067C211.487 52.2505 215.698 50.5659 218.701 47.1968C221.729 43.8276 223.242 39.0303 223.242 32.8047V29.6919C223.242 23.6372 221.814 18.9375 218.958 15.5928C216.125 12.2236 212.097 10.5146 206.873 10.4658H198.669Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M264.258 58C263.867 57.2188 263.55 55.8271 263.306 53.8252C260.156 57.0967 256.396 58.7324 252.026 58.7324C248.12 58.7324 244.91 57.6338 242.395 55.4365C239.905 53.2148 238.66 50.4072 238.66 47.0137C238.66 42.8877 240.222 39.6895 243.347 37.4189C246.497 35.124 250.916 33.9766 256.604 33.9766H263.196V30.8638C263.196 28.4956 262.488 26.6157 261.072 25.2241C259.656 23.8081 257.568 23.1001 254.81 23.1001C252.393 23.1001 250.366 23.7104 248.73 24.9312C247.095 26.1519 246.277 27.6289 246.277 29.3623H239.465C239.465 27.3848 240.161 25.4805 241.553 23.6494C242.969 21.7939 244.873 20.3291 247.266 19.2549C249.683 18.1807 252.332 17.6436 255.212 17.6436C259.778 17.6436 263.354 18.791 265.942 21.0859C268.53 23.3564 269.873 26.4937 269.971 30.4976V48.7349C269.971 52.3726 270.435 55.2656 271.362 57.4141V58H264.258ZM253.015 52.8364C255.139 52.8364 257.153 52.2871 259.058 51.1885C260.962 50.0898 262.341 48.6616 263.196 46.9038V38.7739H257.886C249.585 38.7739 245.435 41.2031 245.435 46.0615C245.435 48.1855 246.143 49.8457 247.559 51.042C248.975 52.2383 250.793 52.8364 253.015 52.8364Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
          <path d="M278.796 37.8218C278.796 33.9399 279.553 30.4487 281.067 27.3481C282.605 24.2476 284.729 21.855 287.439 20.1704C290.173 18.4858 293.286 17.6436 296.777 17.6436C302.173 17.6436 306.531 19.5112 309.851 23.2466C313.196 26.9819 314.868 31.9502 314.868 38.1514V38.6274C314.868 42.4849 314.124 45.9517 312.634 49.0278C311.169 52.0796 309.058 54.46 306.299 56.1689C303.564 57.8779 300.415 58.7324 296.851 58.7324C291.479 58.7324 287.122 56.8647 283.777 53.1294C280.457 49.394 278.796 44.4502 278.796 38.2979V37.8218ZM285.608 38.6274C285.608 43.022 286.621 46.5498 288.647 49.2109C290.698 51.8721 293.433 53.2026 296.851 53.2026C300.293 53.2026 303.027 51.8599 305.054 49.1743C307.08 46.4644 308.093 42.6802 308.093 37.8218C308.093 33.4761 307.056 29.9604 304.98 27.2749C302.93 24.5649 300.195 23.21 296.777 23.21C293.433 23.21 290.735 24.5405 288.684 27.2017C286.633 29.8628 285.608 33.6714 285.608 38.6274Z" stroke="white" strokeWidth="2" mask="url(#path-1-outside-1)"/>
        </svg>
    </LandingSectionHeader>

  );
}